import * as firebase from 'firebase';

var config = {
  apiKey: "AIzaSyBSxUd9MLfCupg2Q39CDOe3KmaQ1Swpmn8",
  authDomain: "healthy-plate-64c54.firebaseapp.com",
  databaseURL: "https://healthy-plate-64c54.firebaseio.com",
  projectId: "healthy-plate-64c54",
  storageBucket: "healthy-plate-64c54.appspot.com",
  messagingSenderId: "844587190403",
  appId: "1:844587190403:web:5a907f08c1244e3a24f3b6",
  measurementId: "G-9D72Q3N9DT"
};

export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app()[0];
